import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function ValDeMarne94Page() {
  return <DeptPage dept={departmentsData["val-de-marne-94"]} />;
}
